import { defineComponent as _defineComponent } from 'vue';
import DatasetLink from "@/components/Dataset/DatasetLink/DatasetLink.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryDatasetLink',
    props: {
        args: null
    },
    setup(__props) {
        const props = __props;
        return { __sfc: true, props, DatasetLink };
    }
});
